import React, { useMemo } from 'react';
import { Text, Link } from '../../../../../ui-kit';
import PaymentOptions from './PaymentOptions';
import PaymentOptionsTitle from './PaymentOptions/components/PaymentOptionsTitle';
import VideoExtrasList from '../../../../VideoExtrasList';
import PaymentSection from './PaymentSection';
import { getTotalCost } from './PaymentOptions/utils/getTotalCost';
import { withStockAssets } from '../../../../../common/hocs';
import { detachMaster, addExtrasTotalCost } from '../../../../../common/utils';
import { OutputAddonsList } from '../../../../AddonsList';
import '../styles/_addons-payment.scss';






















const FAIR_PLAY_POLICY_LINK = 'https://shootsta.com/legal-stuff/';

function openFairPlayPolicy() {
  window.open(FAIR_PLAY_POLICY_LINK, '_blank');
}

export function AddonsPaymentComponent({
  loading,
  videoOutputs,
  addonsSelector,
  videoName,
  totalCost,
  showCreditInfo,
  orgCreditInfo,
  teamCreditInfo,
  getCurrencySymbol,
  creditCost,
  onSelectTeam,
  isBrief,
  appliedStockAssets,
  loadingStockAssets,
  isSaveDisabled,
  onClickTopupCredit,
  hasShutterStockAccess,
  showBufferWarning
}) {
  const totalCredits = `${creditCost} video ${creditCost === 1 ? ' credit' : ' credits'}`;

  const formattedTotalCost = useMemo(() => {
    if (loadingStockAssets) return '-';

    const initialCost = getTotalCost(totalCost);

    const unsignedTotal = appliedStockAssets.length ?
    addExtrasTotalCost(initialCost, appliedStockAssets.map((t) => ({
      ...t,
      cost: hasShutterStockAccess ? '0' : t.cost
    }))) :
    initialCost;

    return `${getCurrencySymbol()}${unsignedTotal}`;
  }, [totalCost, appliedStockAssets, loadingStockAssets]);

  const { master, withoutMaster } = detachMaster(videoOutputs);

  return (
    <div className="addons-payment">
      <PaymentSection
        title={
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <PaymentOptionsTitle videoName={videoName} />
            <Link
            onClick={onClickTopupCredit || void 0}>

              Need more credits?
            </Link>
          </div>}

        footerTotalText="Total"
        footerTotalValue={totalCredits}>

        <PaymentOptions
          loading={loading}
          showCreditInfo={showCreditInfo}
          orgCreditInfo={orgCreditInfo}
          teamCreditInfo={teamCreditInfo}
          onSelectTeam={onSelectTeam}
          isSaveDisabled={isSaveDisabled}
          showBufferWarning={showBufferWarning} />

      </PaymentSection>

      <PaymentSection
        title="Selected Add-ons"
        footerTotalText="Estimated Subtotal"
        footerTotalValue={formattedTotalCost}
        footerStartAdornment="Subject to approval"
        footerStartAdornmentIcon="positive"
        isTitleString
        hasBottomDivider>

        <OutputAddonsList
          videoOutput={master || videoOutputs[0]}
          additionalOutputs={withoutMaster}
          addonsSelector={addonsSelector}
          isBrief={isBrief} />

        <VideoExtrasList
          listExtras={appliedStockAssets}
          hasShutterStockAccess={hasShutterStockAccess} />

      </PaymentSection>

      <Text className="addons-payment__foot-note" noMargin heading5>
        As these costs may change during production,
        you will be invoiced after project completion.
        <br />
        Stock assets shown are reflective of your selection.
        You will be charged only for assets used
        <br />
        in your final edit.
        By submitting you agree to our
        {' '}
        <Link onClick={openFairPlayPolicy} className="addons-payment__foot-note-link">
          Terms of Service
        </Link>
      </Text>
    </div>);

}

export default withStockAssets(AddonsPaymentComponent);